// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606151211/js/" + chunkId + "." + {"44":"f047ada5","225":"5ce7f230","481":"14ceae5c","486":"91c0f751","770":"ef5da6f2"}[chunkId] + ".0.04262669495313842.chunk.js";
};